import { userTasteQueryOptions } from '@/api/queries/users';
import { useQuery } from '@tanstack/react-query';

/**
 * Hook to fetch a user's aggregate taste distribution for their profile.
 * The "taste you trust" signal behind the profile's segmented rating bar.
 */
export function useProfileTaste(userId: string) {
  return useQuery(userTasteQueryOptions(userId));
}
